const data = [{
  Year: 2012,
  Football: 3.8488,
  "Men's basketball": 0.0,
  'Non-program Specific': 0.0,
  "Other men's sports": 0.0,
  "Other women's sports": 0.0,
  "Women's basketball": 0.0,
  Total: 3.8488,
}, {
  Year: 2013,
  Football: 6.7673015,
  "Men's basketball": 0.0,
  'Non-program Specific': 11.16073136,
  "Other men's sports": -0.44689938,
  "Other women's sports": -0.44689938,
  "Women's basketball": 0.0,
  Total: 17.0342341,
}, {
  Year: 2014,
  Football: 14.33618543,
  "Men's basketball": 0.0,
  'Non-program Specific': 6.83758692,
  "Other men's sports": 0.0,
  "Other women's sports": 0.0,
  "Women's basketball": 0.0,
  Total: 21.17377235,
}, {
  Year: 2015,
  Football: 12.53364639,
  "Men's basketball": 0.0,
  'Non-program Specific': 10.45950898,
  "Other men's sports": 0.07312551,
  "Other women's sports": 0.01253932,
  "Women's basketball": 0.0,
  Total: 23.0788202,
}, {
  Year: 2016,
  Football: 13.6076317,
  "Men's basketball": 0.0,
  'Non-program Specific': 10.3105353,
  "Other men's sports": 0.2101814,
  "Other women's sports": 0.0025272,
  "Women's basketball": 0.0,
  Total: 24.1308756,
}, {
  Year: 2017,
  Football: 18.26935808,
  "Men's basketball": 0.25088,
  'Non-program Specific': 5.28001024,
  "Other men's sports": 0.29245056,
  "Other women's sports": 0.07523456,
  "Women's basketball": 0.0,
  Total: 24.16793344,
}, {
  Year: 2018,
  Football: 17.89154956,
  "Men's basketball": 0.24304,
  'Non-program Specific': 5.16328684,
  "Other men's sports": 0.28041484,
  "Other women's sports": 0.06998684,
  "Women's basketball": 0.0,
  Total: 23.64827808,
}, {
  Year: 2019,
  Football: 10.24068,
  "Men's basketball": 0.23912,
  'Non-program Specific': 0.67926428,
  "Other men's sports": 0.27729746,
  "Other women's sports": 0.07026224,
  "Women's basketball": 0.0,
  Total: 11.50662398,
}, {
  Year: 2020,
  Football: 5.91374795,
  "Men's basketball": 0.0,
  'Non-program Specific': 5.00180362,
  "Other men's sports": 0.2629451,
  "Other women's sports": 0.08289952,
  "Women's basketball": 0.0,
  Total: 11.26139619,
}, {
  Year: 2021,
  Football: 5.51749185,
  "Men's basketball": 0.0,
  'Non-program Specific': 4.4110136,
  "Other men's sports": 0.20094985,
  "Other women's sports": 0.0064377,
  "Women's basketball": 0.0,
  Total: 10.135893,
}, {
  Year: 2022,
  Football: 5.24761335,
  "Men's basketball": 0.0,
  'Non-program Specific': 4.0171971,
  "Other men's sports": 0.18418995,
  "Other women's sports": 0.00600495,
  "Women's basketball": 0.0,
  Total: 9.45500535,
}, {
  Year: 2023,
  Football: 5.02315524,
  "Men's basketball": 0.0,
  'Non-program Specific': 3.80324136,
  "Other men's sports": 0.17904468,
  "Other women's sports": 0.0054927,
  "Women's basketball": 0.0,
  Total: 9.01093398,
}];

export default data;
